import { render } from "./SettingsMenu.vue?vue&type=template&id=023d6918&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"

import "./SettingsMenu.vue?vue&type=style&index=0&id=023d6918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023d6918"]])

export default __exports__